import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react'
import * as HoverCardPrimitive from '@radix-ui/react-hover-card'

import cn from '@components/utils/cn'

import { overlayContentClass } from './overlayContentStyles'

const HoverCard = HoverCardPrimitive.Root
const HoverCardTrigger = HoverCardPrimitive.Trigger

const HoverCardContent = ({
  className,
  align = 'center',
  sideOffset = 4,
  portal = false,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content> & {
  ref?: Ref<ComponentRef<typeof HoverCardPrimitive.Content>>
  portal?: boolean
}) => {
  const content = (
    <HoverCardPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(overlayContentClass, 'tw:w-64', className)}
      {...props}
    />
  )

  return portal ? (
    <HoverCardPrimitive.Portal>
      <div className="tailwind">{content}</div>
    </HoverCardPrimitive.Portal>
  ) : (
    content
  )
}

export { HoverCard, HoverCardTrigger, HoverCardContent }
